/* eslint-disable @typescript-eslint/no-var-requires */

import { $t, $thesaurus } from '../base-facade';

import { createThesaurusService } from '../thesaurus-service';

import LiveChannelsRepository from './repositories/live-channels-repository';
import LiveEventsRepository from './repositories/live-event-repository';

import { BroadcastEvent, BroadcastSource } from './types/Broadcast';
import { LiveSource, LiveSource$Details, RMSAccount, RMSLanguage } from './types/Live';
import { TimeZone } from './types/TimeZone';

import BaseRepository from '@/repositories/base-repository';
import LiveEventTemplateRepository from './repositories/live-event-template-repository';

const broadcastEventsRepository = new BaseRepository<BroadcastEvent>('/broadcast/event');
const broadcastSourcesRepository = new BaseRepository<BroadcastSource>('/broadcast/source');
const liveChannelsRepository = new LiveChannelsRepository();
const liveEventsRepository = new LiveEventsRepository();
const liveEventTemplateRepository = new LiveEventTemplateRepository();

const liveSourcesService = createThesaurusService<LiveSource, LiveSource$Details>('/live/source');
const liveChannelsService = createThesaurusService(liveChannelsRepository);
const rmsAccountsService = createThesaurusService<RMSAccount>('/ams/account');
const rmsLanguagesService = createThesaurusService<RMSLanguage>('/ams/live-cc-language');
const timeZonesService = createThesaurusService<TimeZone>('/timezone');

export {
  $t,
  $thesaurus,
  broadcastEventsRepository,
  broadcastSourcesRepository,
  liveChannelsRepository,
  liveEventsRepository,
  liveSourcesService,
  liveChannelsService,
  rmsAccountsService,
  rmsLanguagesService,
  timeZonesService,
  liveEventTemplateRepository,
};

if (process.env.VUE_APP_MOCK_API === 'yes') {
  (function _bootstrap() {
    const adapert = require('@/mocks/index').default;
    require('./mocks/rms-accounts').default(adapert);
    require('./mocks/ams-languages').default(adapert);
    require('./mocks/broadcast-events').default(adapert);
    require('./mocks/broadcast-sources').default(adapert);
    require('./mocks/live-channels').default(adapert);
    require('./mocks/live-events').default(adapert);
    require('./mocks/live-sources').default(adapert);
    require('./mocks/time-zones').default(adapert);
  })();
}
